/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The authentication method used.
*/
export enum AuditLogAuthMethod {
  LocalUser = 'LOCAL_USER',
  Sso = 'SSO'
}
